type StatusPillColor = "green" | "gray"

interface StatusPillProps {
  text: string
  color: StatusPillColor
}

const colorClassByColor: Record<StatusPillColor, string> = {
  green: "color-accent-green",
  gray: "color-subtle",
}

export function StatusPill({ text, color }: StatusPillProps) {
  return <span className={`text-body ${colorClassByColor[color]}`}>{text}</span>
}
